/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { getEntryTaskInfo } from '../components/Journal/JournalEntryModal/utils';
import { notaryAPI } from '../api/notary';
import { Dispatch } from '../redux';

export function fetchJournalEntry(id: string, isLocked: boolean) {
  return async (dispatch: Dispatch) => {
    const entry = await notaryAPI.journal.getJournalEntry(id);
    const documents = entry.callId ? await notaryAPI.documents.fetchCallDocuments(entry.callId) : [];
    dispatch({
      type: 'SET_JOURNAL_ENTRY',
      payload: {
        // entry task is used to build the entry task form ui and handles prefill. we also need current entry so
        // that we can build the new signers array with the original values and new values and patch to the backend
        entryTask: getEntryTaskInfo(entry, documents),
        current: entry,
        isLocked,
      },
    });
  };
}
